import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DeleteCurrentUserRequest } from '@dto/deleteCurrentUserRequest';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-delete-user-profile-dialog-content',
  templateUrl: './delete-user-profile-dialog-content.component.html',
  styleUrls: ['./delete-user-profile-dialog-content.component.scss'],
  providers: [FormService]
})
export class DeleteUserProfileDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DeleteUserProfileDialogContentComponent';

  public form: UntypedFormGroup;
  public isWrongPassword: Boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public formService: FormService,
    private usersService: UsersService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.formService.form = new UntypedFormGroup({
      currentPassword: new UntypedFormControl('', [Validators.required])
    });
  }

  onSubmit(formValue) {
    const deleteUserProfileRequest: DeleteCurrentUserRequest = {
      currentPassword: formValue.currentPassword
    }

    this.usersService.deleteCurrentUser(deleteUserProfileRequest).subscribe(result => {
      if (result.isSuccess) {
        this.activeModal.close({ isSuccess: result.isSuccess });
        this.toastService.success($localize`:@@DeletedCustomerDialogSuccess:Kunde wurde erfolgreich gelöscht`);
      } else {
        this.isWrongPassword = true;
      }
    }, error => {
      this.toastService.error($localize`:@@DeletedCustomerDialogError:Kunde konnte nicht gelöscht werden`);
      this.messageService.setError(error);
    });
  }

  resetWrongPassword() {
    this.isWrongPassword = false;
  }
}
